// src/components/ui/boutons.js
// ============================================================================
// Les couleurs des boutons de KLASYS, à poser sur `Button` (ui/button.jsx)
// ============================================================================
//
// `Button` fixe la taille (h-9, sm, icon : DESIGN-SYSTEM.md, « Boutons »), pas
// la couleur. Ses variantes `outline`, `secondary` et `ghost` s'appuient sur
// des variables CSS de shadcn (--input, --background, --accent) que KLASYS ne
// définit nulle part : seules, elles rendent un bouton transparent, sans
// survol ni anneau de focus. Constaté sur le module Logistique le 04/11/2026.
//
// Les teintes sont celles des boutons de la Vie scolaire (VieScolairePage.jsx,
// BOUTON_PRINCIPAL / BOUTON_SECONDAIRE).
// ============================================================================

/** Action principale : fond bleu, texte blanc. */
export const BOUTON_PLEIN = 'bg-[#246990] text-white shadow-sm hover:bg-[#1f5a7a]';

/** Action secondaire : fond blanc bordé de gris, survol gris clair. */
export const BOUTON_CONTOUR = 'border border-gray-300 bg-white text-gray-700 shadow-sm hover:bg-gray-50 hover:text-gray-900';

/** Action qui retire ou annule quelque chose : bordé de rouge. */
export const BOUTON_DANGER = 'border border-red-200 bg-white text-red-600 shadow-sm hover:bg-red-50';

/** Les boutons d'un même pied de fenêtre : même hauteur, même largeur. */
export const BOUTON_PIED = 'h-9 min-w-[168px] justify-center gap-2';
